import {
  IconButton,
  Step,
  StepConnector,
  StepLabel,
  Stepper,
  Typography,
  Dialog,
  AppBar,
  Toolbar,
  Button,
} from "@mui/material";
import InvestigatorContainer from "../../../components/contsiners/InvestigatorContainer";
import CAMHeader from "../../../components/Header/CAMHeader";
import CAMSubHeader from "../../../components/Header/CAMSubHeader";
import CAMDrawer from "../../../components/LeftSideBar/CAMDrawer";
import { action } from "../../../constants/action";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import HideImageOutlinedIcon from "@mui/icons-material/HideImageOutlined";
import styled from "styled-components";
import MapFooter from "../../../components/Controls/Footer/MapFooter";
import ProgressBar from "../../../components/ProgressBar";
import ModalProcessor from "../../../components/Modal/RejectModal/ModalProcessor";
import CustomizedSnackbars from "../../../components/Snackbars/CustomizedSnackbars";
import { useEffect, useRef, useState } from "react";
import {
  clearApiStatus,
  getValiData,
  isSignatureUploaded,
  validateUserClear,
} from "../../../redux/validation/actions";
import { useLocation, useNavigate } from "react-router-dom";
import "./mapData.scss";
import { useDispatch, useSelector } from "react-redux";
import DataValidationContainer from "./DataValidationContainer";
import Label from "../../../components/Label/Label";

const ColorlibConnector = styled(StepConnector)({
  alternativeLabel: {},
  active: {
    "& $line": {
      borderBottom: "3px solid rgba(0,0,0,0.7)",
      fontWeight: 700,
    },
  },
  completed: {
    "& $line": {
      borderColor: "rgba(0,0,0,0.7)",
      borderBottom: "3px solid rgba(0,0,0,0.7)",
      borderTopWidth: "0px!important",
    },
  },
  line: {
    height: 3,
    border: 0,
    backgroundColor: "#B9B9B9",
    borderRadius: 1,
    borderTopWidth: "0px!important",
  },
});

const DataValidation = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { projectId, batchId, forValue } = location.state || {};

  const coorData = useSelector((state) => state.validation.coorData);
  const apiStatus = useSelector((state) => state.validation.apiStatus);
  // const signUploaded = useSelector((state) => state.validation.signUploaded?.isSignatureUploaded);
  const signUploaded = true;

  const entireBatchRejectedByInvestigatorValidator = useSelector(
    (state) =>
      state.validation.coorData?.mapping_details
        ?.entireBatchRejectedByInvestigatorValidator,
  );

  const child = useRef(null);
  const qcChildRef = useRef(null);
  const intervalRef = useRef(null);

  const [state, setState] = useState({
    leftgrid: 6,
    rightgrid: 6,
    isFullScreen: true,
    hideScreen: true,
    openAuth: false,
    openSignPad: false,
    // signUploaded: false,
    action: "",
    batchRejection: false,
    rejectionRemark: "",
    openRejectionModal: false,
    sucessNotification: false,
    errorNotification: false,
    message: "",
    loader: false,
    isPreviewOpen: false,
  });
  const [previewData, setPreviewData] = useState(null);

  /* ---------- equivalent of componentDidUpdate ---------- */
  useEffect(() => {
    if (entireBatchRejectedByInvestigatorValidator) {
      setState((prev) => ({
        ...prev,
        batchRejection: entireBatchRejectedByInvestigatorValidator,
      }));
    }
  }, [entireBatchRejectedByInvestigatorValidator]);

  useEffect(() => {
    setState((prev) => ({
      ...prev,
      loader: apiStatus?.loader,
    }));

    if (apiStatus?.loader === false && apiStatus?.message) {
      if (
        apiStatus.message === "error" ||
        apiStatus.message === "Server Error Please Try Again..."
      ) {
        setState((prev) => ({
          ...prev,
          sucessNotification: false,
          errorNotification: true,
          message: "Something went wrong please try again",
        }));
        dispatch(clearApiStatus());
      } else if (apiStatus.next === false) {
        setState((prev) => ({
          ...prev,
          sucessNotification: true,
          message: "Successfully updated",
        }));
        dispatch(clearApiStatus());
      }
    }

    if (apiStatus?.loader === false && apiStatus?.next === true) {
      setState((prev) => ({
        ...prev,
        sucessNotification: true,
        errorNotification: false,
        message: "Successfully updated",
      }));

      setTimeout(() => {
        setState((prev) => ({
          ...prev,
          sucessNotification: false,
          message: "",
        }));
        navigate(`/${"data-validation"}`);
        dispatch(clearApiStatus());
      }, 2000);
    }

    if (apiStatus?.loader === false && apiStatus?.isError) {
      setState((prev) => ({
        ...prev,
        sucessNotification: false,
        errorNotification: true,
        message: apiStatus.message,
      }));
      dispatch(clearApiStatus());
    }

    if (apiStatus?.loader === false && apiStatus?.isRejected) {
      setState((prev) => ({
        ...prev,
        sucessNotification: true,
        errorNotification: false,
        message: "Successfully updated",
      }));

      setTimeout(() => {
        setState((prev) => ({
          ...prev,
          sucessNotification: false,
          message: "",
        }));
        navigate(`/${"data-validation"}`);
        dispatch(clearApiStatus());
      }, 2000);
    }
  }, [apiStatus, navigate]);

  /* ---------- Handlers ---------- */

  const onClickFooterAction = (action, e, autoSave = false) => {
    if (action === "preview") {
      setPreviewData(child.current?.getCurrentData());

      setState((prev) => ({ ...prev, isPreviewOpen: true }));

      return;
    }
    if (action === "cancel") {
      navigate(`/${"data-validation"}`);
      return;
    }

    if (action === "reject") {
      if (!e?.target?.checked) {
        setState((prev) => ({
          ...prev,
          batchRejection: false,
          rejectionRemark: "",
        }));
      } else {
        setState((prev) => ({
          ...prev,
          openRejectionModal: true,
        }));
      }
      return;
    }

    setState((prev) => ({ ...prev, action }));

    if (child.current) {
      if (action === "saveAndNext") {
        if (state.batchRejection) {
          child.current.mapData("reject", state.rejectionRemark, true);
        } else {
          child.current.mapData(
            "saveAndNext",
            state.rejectionRemark,
            false,
            signUploaded,
          );
        }
      } else {
        child.current.mapData(action, null, null, null, autoSave);
      }
    }
  };

  const handleCloseModal = () => {
    setState((prev) => ({
      ...prev,
      openRejectionModal: false,
      batchRejection: false,
    }));
  };

  const handleReject = (remark) => {
    setState((prev) => ({
      ...prev,
      openRejectionModal: false,
      batchRejection: true,
      rejectionRemark: remark,
    }));
  };

  const slideScreentoMaximize = () => {
    setState((prev) => ({
      ...prev,
      rightgrid: 12,
      isFullScreen: false,
      hideScreen: false,
    }));
  };

  const slideScreentoMinimize = () => {
    setState((prev) => ({
      ...prev,
      leftgrid: 6,
      rightgrid: 6,
      isFullScreen: true,
      hideScreen: true,
    }));
  };

  useEffect(() => {
    dispatch(clearApiStatus());
    dispatch(getValiData(projectId, batchId, forValue));
    dispatch(isSignatureUploaded());
    dispatch(validateUserClear());
    // acts.clearIsSignatureUploadedStatus();
  }, []);

  const handleClosePreview = () => {
    setState((prev) => ({ ...prev, isPreviewOpen: false }));
  };

  const handlePreviewSubmit = () => {
    // setState((prev) => ({ ...prev, isPreviewOpen: false }));
    onClickFooterAction("saveAndNext");
  };

  return (
    <>
      <CAMHeader />
      <CAMDrawer />
      <InvestigatorContainer>
        {/* <CAMSubHeader text={action.DATA_VALIDATION} /> */}

        <div className="fullscreen-view">
          {state.isFullScreen ? (
            <div>
              <IconButton
                aria-label="expand row"
                size="small"
                onClick={() => slideScreentoMaximize()}
              >
                <ImageOutlinedIcon />
              </IconButton>
            </div>
          ) : (
            <div>
              <IconButton
                aria-label="expand row"
                size="small"
                onClick={() => slideScreentoMinimize()}
              >
                <HideImageOutlinedIcon />
              </IconButton>
            </div>
          )}
          <Typography className="project-batch-header">
            {localStorage.projectName + " - " + localStorage.batchName}
          </Typography>

          <Stepper
            activeStep={state.activeStep}
            connector={<ColorlibConnector />}
          >
            <Step key="Data Validation" className="stepper-wrap-label">
              <StepLabel>Data Validation</StepLabel>
            </Step>
          </Stepper>
        </div>

        <DataValidationContainer
          child={child}
          // qcChild={qcChild}
          // isFullView={state?.isFullView}
          hideScreen={state?.hideScreen}
          leftgrid={state?.leftgrid}
          rightgrid={state?.rightgrid}
          // assignToValidator={state.assignToValidator}
          forValue={forValue}
          isPreviewOnly={false}
        />

        <MapFooter
          onClickFooterAction={onClickFooterAction}
          batchRejection={state.batchRejection}
          forValue={forValue}
          submitOnReview={true}
          // role="investigatorValidatior"
          // isShowReject={true}
          // isPrevious={false}
        />

        {apiStatus?.loader ? <ProgressBar /> : ""}
        {state.openRejectionModal && (
          <ModalProcessor
            modalOpen={state.openRejectionModal}
            handleClose={handleCloseModal}
            handleReject={handleReject}
            isShowClearButton={false}
            isShowDeleteButton={false}
            heading="Do you want to reject the batch?"
          />
        )}
        {state?.sucessNotification && (
          <CustomizedSnackbars
            severity="success"
            state={state?.sucessNotification}
            text={state?.message}
            handleClose={() =>
              setState((prev) => ({
                ...prev,
                sucessNotification: false,
              }))
            }
          />
        )}
        {state?.errorNotification && (
          <CustomizedSnackbars
            severity="error"
            state={state?.errorNotification}
            text={state.message}
            handleClose={() =>
              setState((prev) => ({
                ...prev,
                errorNotification: false,
              }))
            }
          />
        )}
        <Dialog fullScreen open={state.isPreviewOpen}>
          {/* Header (Reduced Height) */}
          <AppBar
            position="static"
            sx={{ minHeight: 48, backgroundColor: "var(--ternary-body-color)" }}
          >
            <Toolbar variant="dense">
              <Label
                text="Preview Data Validation"
                fontWeight="500"
                fontSize="16px"
                // color="inherit"
              />
            </Toolbar>
          </AppBar>

          {/* Content */}
          <div
            style={{
              padding: "8px 16px",
              paddingBottom: 56, // space for footer
              height: "calc(100vh - 48px)",
              overflow: "auto",
            }}
          >
            <DataValidationContainer
              hideScreen={false}
              leftgrid={12}
              rightgrid={12}
              forValue="viewOnly"
              parametersDataFromChildByRefToViewonly={previewData}
              isPreviewOnly={true}
            />
          </div>

          {/* Footer */}
          <div
            style={{
              position: "fixed",
              bottom: 0,
              left: 0,
              width: "100%",
              padding: "8px 16px",
              borderTop: "1px solid #e5e7eb",
              backgroundColor: "#fff",
              display: "flex",
              justifyContent: "flex-end",
              gap: "12px",
              zIndex: 1300,
            }}
          >
            <Button
              size="small"
              variant="outlined"
              onClick={handleClosePreview}
            >
              Previous
            </Button>

            <Button
              size="small"
              variant="contained"
              onClick={handlePreviewSubmit}
            >
              Submit
            </Button>
          </div>
        </Dialog>
      </InvestigatorContainer>
    </>
  );
};

export default DataValidation;
